import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CitiesContext = createContext(null);

export function CitiesProvider({ children }) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    return api
      .get("/cities")
      .then(({ data }) => setCities(data))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const getCity = (slug) => cities.find((c) => c.slug === slug) || null;

  return (
    <CitiesContext.Provider value={{ cities, loading, getCity, refresh }}>
      {children}
    </CitiesContext.Provider>
  );
}

export const useCities = () => useContext(CitiesContext);
